import React from "react";
import { Container } from "./common/Container";
import Logo from "../assets/white logo.svg";

import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTiktok,
} from "react-icons/fa6";

const Footer = () => {
  return (
    <>
      <div className="relative bg-custom-dark-blue pt-20">
        <Container
          className={
            "flex flex-wrap items-start justify-between pb-10 sm:pb-20 md:flex-nowrap"
          }
        >
          <div className="mb-6 w-full md:mb-0 md:mr-8 md:w-[450px]">
            <img
              src={Logo}
              alt="logo not found"
              className="w-[160px] sm:w-[260px]"
            />
            <p className="mb-4 mt-4 max-w-[500px] text-sm font-light tracking-wide text-gray-300">
              Hub Be-Connect is a dynamic tech start-up based in Chitral,
              dedicated to equipping individuals and businesses with essential
              freelancing skills. We offer short courses and diplomas in areas
              like bookkeeping and graphic design, empowering professionals to
              thrive in the digital economy.
            </p>
            <ul className="mt-8 flex items-center gap-x-2 p-0">
              <li>
                <a
                  href="mailto:"
                  className="group flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-md bg-white transition duration-300"
                >
                  <FaEnvelope className="text-[22px] text-custom-dark-blue transition duration-300 group-hover:text-custom-orange" />
                </a>
              </li>
              <li>
                <a
                  href="https://web.facebook.com/hubbeconnect/"
                  className="group flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-md bg-white transition duration-300"
                >
                  <FaFacebook className="text-[22px] text-custom-dark-blue transition duration-300 group-hover:text-custom-orange" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/beconnect1/"
                  className="group flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-md bg-white transition duration-300"
                >
                  <FaInstagram className="text-[22px] text-custom-dark-blue transition duration-300 group-hover:text-custom-orange" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.hub-beconnect-smc-pvt-ltd"
                  className="group flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-md bg-white transition duration-300"
                >
                  <FaLinkedin className="text-[22px] text-custom-dark-blue transition duration-300 group-hover:text-custom-orange" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.hub-beconnect-smc-pvt-ltd"
                  className="group flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-md bg-white transition duration-300"
                >
                  <FaTiktok className="text-[22px] text-custom-dark-blue transition duration-300 group-hover:text-custom-orange" />
                </a>
              </li>
            </ul>
          </div>

          <ul className="mb-4 px-2 pt-2 sm:mb-0">
            <h3 className="mb-6 text-lg font-medium text-white sm:text-xl">
              Discover
            </h3>
            <li className="mb-3 text-sm text-gray-300 transition duration-300 hover:text-white">
              <a href="/about">About us</a>
            </li>
            <li className="mb-3 text-sm text-gray-300 transition duration-300 hover:text-white">
              <a href="/service-details/graphic-design">Our Services</a>
            </li>
            <li className="mb-3 text-sm text-gray-300 transition duration-300 hover:text-white">
              <a href="#teams">Meet Our team</a>
            </li>
            <li className="mb-3 text-sm text-gray-300 transition duration-300 hover:text-white">
              <a href="#testimonial">Clients Testimonials</a>
            </li>
            <li className="mb-3 text-sm text-gray-300 transition duration-300 hover:text-white">
              <a href="/courses">Our Courses</a>
            </li>
            <li className="mb-3 text-sm text-gray-300 transition duration-300 hover:text-white">
              <a href="/contact">Contact us</a>
            </li>
          </ul>

          <ul className="mb-4 px-2 pt-2 sm:mb-0">
            <h3 className="mb-6 text-lg font-medium text-white sm:text-xl">
              Working Hours
            </h3>
            <li className="mb-3 text-sm text-gray-300 transition duration-300 hover:text-white">
              Mon - Fri: <span className="ps-[15px]">09:00 - 06:00</span>
            </li>
            <li className="mb-3 text-sm text-gray-300 transition duration-300 hover:text-white">
              Saturday: <span className="ps-[20px]">09:00 - 12:00</span>
            </li>
            <li className="mb-3 text-sm text-gray-300 transition duration-300 hover:text-white">
              Sunday <span className="ps-[35px]">Closed</span>
            </li>
            <h3 className="mb-4 mt-8 text-lg font-medium text-white sm:text-xl">
              Need Help?
            </h3>
            <li className="text-md text-gray-300 transition duration-300 hover:text-white">
              0943 413871
            </li>
          </ul>
        </Container>
        <div className="after:content-[' '] relative py-6 after:absolute after:left-[10%] after:top-0 after:w-[80%] after:border after:border-dashed after:border-gray-500">
          <Container>
            <p className="text-center text-xs text-white">
              2025 © HUB BE CONNECT SMC (PVT) LTD. All rights reserved.
            </p>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Footer;
